/* eslint-disable react/prop-types */
import { strCode, consentAttributes, consentGroups, consentTypes } from "../../../consts";
import { t } from "../../../services";

import { GradientLoader, TextOverflowWrapper } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

export const ConsentElementsTableColumns = [
  {
    Header: strCode.POSITION_TITLE,
    accessor: "position",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`56px`} justifyContent="flex-end">
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={55} height={24} animationDuration={48} />
            ) : (
              cell.value?.toString()
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.NAME_TITLE,
    accessor: "name",
    Cell: ({ cell, isLoading, cellWidth5 }) => {
      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={120} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ATTRIBUTE_TITLE,
    accessor: "code",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`160px`}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={120} height={24} animationDuration={40} />
            ) : (
              t(consentAttributes.find((opt) => opt.id === cell.value)?.value)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.GROUP_TITLE,
    accessor: "groupName",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`160px`}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={120} height={24} animationDuration={40} />
            ) : (
              t(consentGroups.find((opt) => opt.id === cell.value)?.value)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.TYPE_TITLE,
    accessor: "type",
    Cell: ({ cell, cellWidth3, isLoading }) => {
      return (
        <CellWrapper width="100%" minWidth={`${cellWidth3}px`}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={120} height={24} animationDuration={40} />
            ) : (
              t(consentTypes.find((opt) => opt.id === cell.value)?.value)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
